import { faImage } from '@fortawesome/pro-solid-svg-icons';
import { optimizedImageSrc } from 'corso-web-lib';
import iconToDataUri from '~/utils/iconToDataUri';

// ? maybe use a data URL of an SVG for these instead to guarantee it's always available
export const FALLBACK_IMAGE = iconToDataUri(faImage);

type ImageElementProps = React.DetailedHTMLProps<
  React.ImgHTMLAttributes<HTMLImageElement>,
  HTMLImageElement
>;

type FallbackImageProps = Omit<
  ImageElementProps,
  'onError' | 'onLoad' | 'alt' | 'src'
> & {
  src?: string | null; // additionally support `null` since it'll be defaulted here anyway
  /** `alt` text is required.
   * @see https://webaim.org/techniques/alttext/
   * @see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#alt
   * @see https://github.com/jsx-eslint/eslint-plugin-jsx-a11y/blob/main/docs/rules/alt-text.md
   */
  alt: string;
};

// ? maybe show the fallback image or something else while loading instead of only on error
export default function FallbackImage({
  src,
  alt,
  ...props
}: FallbackImageProps) {
  return (
    <img
      src={src ? optimizedImageSrc(src) : FALLBACK_IMAGE}
      alt={alt}

      onError={({ currentTarget }) => {
        // oxlint-disable-next-line no-param-reassign
        currentTarget.onerror = null; // ? maybe someday `removeEventListener`
        // oxlint-disable-next-line no-param-reassign
        currentTarget.src = FALLBACK_IMAGE;
      }}
      {...props}
    />
  );
}
